// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedCustomFormsStyles } from "@awc/App/SharedStyles/SharedCustomFormsStyles";
import { mainRfqFormStyles } from "@awc/App/Widgets/CustomForms/MainRfqForm";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

mainRfqFormStyles.formWrapper = {
    ...sharedCustomFormsStyles.formWrapper,
};

mainRfqFormStyles.inputsWrapper = {
    ...sharedCustomFormsStyles.inputsWrapper,
};

mainRfqFormStyles.fileUpload = {
    ...mergeWithCss(sharedCustomFormsStyles.fileUpload, {
        css: css`
            max-width: 600px;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
            }
        `,
    }),
};

mainRfqFormStyles.submitButton = {
    ...mergeWithCss(sharedCustomFormsStyles.submitButton, {
        css: css`
            margin: 0 auto;
            margin-top: 20px;
        `,
    }),
};

mainRfqFormStyles.infoLabel = {
    weight: fontConfig.weight.bold,
    css: css`
        margin-top: 20px;
        display: block;
    `,
};
